var _path, _polygon, _polygon2, _polygon3, _polygon4, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoVectra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "All_Logos",
    "data-name": "All Logos",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 380 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M349.21,58.41c.59,0,1.25,0,1.25-.75,0-.63-.5-.72-1-.72h-1v1.47Zm-.7,2.5h-.61V56.43h1.72c1,0,1.45.44,1.45,1.24a1.2,1.2,0,0,1-1,1.25l1.25,2h-.69l-1.22-2h-.87Zm3.95-2.25a3.16,3.16,0,1,0-3.15,3.27,3.16,3.16,0,0,0,3.15-3.27m.61,0a3.77,3.77,0,1,1-3.76-3.76,3.76,3.76,0,0,1,3.76,3.76",
    fill: "#4a8b2c"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "239.27 56.27 190.47 56.27 190.47 62.33 211.88 62.33 211.88 103.7 217.94 103.7 217.94 62.33 239.27 62.33 239.27 56.27",
    fill: "#4a8b2c"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "80.12 56.27 73.17 56.27 52.24 97.07 31.32 56.27 24.45 56.27 48.85 103.78 52.24 103.78 55.72 103.78 80.12 56.27",
    fill: "#4a8b2c"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "355.55 103.78 331.15 56.19 324.36 56.27 299.96 103.78 306.75 103.78 327.76 62.9 348.68 103.78 355.55 103.78",
    fill: "#4a8b2c"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "131.82 62.33 131.82 56.27 94.01 56.27 87.95 56.27 87.95 103.7 87.95 103.78 131.82 103.78 131.82 97.72 94.01 97.72 94.01 83.02 130.38 83.02 130.38 76.96 94.01 76.96 94.01 62.33 131.82 62.33",
    fill: "#4a8b2c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M164.54,105.58a28.3,28.3,0,0,0,19.77-7.92,1.86,1.86,0,0,1,.47-.43L180,93.14A22.87,22.87,0,0,1,164.54,99c-11.76,0-21.33-8.52-21.33-19s9.57-19,21.33-19a22.81,22.81,0,0,1,15.37,5.82l4.79-4.09a28.08,28.08,0,0,0-20.16-8.35c-15.06,0-27.29,11.49-27.29,25.58s12.23,25.58,27.29,25.58",
    fill: "#4a8b2c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M253.25,62.33h28.94a7.24,7.24,0,0,1,7.27,7.27A7.42,7.42,0,0,1,282.59,77H253.25ZM295.6,69.6a13.31,13.31,0,0,0-13.41-13.33h-35v47.51h6.14V83h24.82l10.66,20.77h6.87l-10.9-21A13.43,13.43,0,0,0,295.6,69.6",
    fill: "#4a8b2c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVectra);
export default __webpack_public_path__ + "static/media/logo_vectra.2a0e1f5d264b8f4e1dff55007af16c9f.svg";
export { ForwardRef as ReactComponent };